<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="Modules.FINANZAS" :profile-id="Profiles.PERSONAL" reference="cheques" summary-only />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button>
              <b-button v-if="selected.length && tab == TABS.PORTFOLIO" variant="dark" size="sm" class="mr-1" @click="depositSelected"><AppIcon name="account_balance" class="mr-1" /> Depositar ({{ selected.length }})</b-button>
              <b-button variant="link" class="list-view-icon-btn list-view-icon-btn--primary" v-b-tooltip.hover.bottom title="Agregar cheque" aria-label="Agregar cheque" @click="add"><AppIcon name="add" /></b-button>
            </div>
          </div>
        </section>
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width:150px;"><label class="filter-label">Desde (vto.)</label><b-form-input type="date" size="sm" v-model="filters.date_start" /></div>
            <div class="list-view-filter" style="width:150px;"><label class="filter-label">Hasta (vto.)</label><b-form-input type="date" size="sm" v-model="filters.date_end" /></div>
            <div class="list-view-filter" style="flex:1 1 180px;max-width:240px;" v-if="tab == TABS.ALL"><label class="filter-label">Estado</label><v-select :options="arr.filters.available" v-model="filters.available" placeholder="Todos" :multiple="false" :select-on-tab="true" /></div>
            <b-button variant="outline-dark" size="sm" @click="load" v-b-tooltip.hover title="Aplicar filtros" style="height:31px;width:31px;padding:0;flex-shrink:0;"><AppIcon name="filter" /></b-button>
          </div>
        </b-collapse>
      </b-card>

      <!-- INDICADORES (sobre toda la cartera, sin filtros) -->
      <div class="cheques-kpis">
        <button type="button" class="cheques-kpi cheques-kpi--portfolio" :class="{ 'cheques-kpi--active': tab == TABS.PORTFOLIO }" @click="setTab(TABS.PORTFOLIO)">
          <span class="cheques-kpi__icon"><AppIcon name="account_balance_wallet" /></span>
          <span class="cheques-kpi__body"><small>En cartera</small><strong>{{ formatCurrency(summary.portfolio.amount) }}</strong><span>{{ summary.portfolio.count }} {{ summary.portfolio.count == 1 ? 'cheque' : 'cheques' }}</span></span>
        </button>
        <button type="button" class="cheques-kpi cheques-kpi--pending" :class="{ 'cheques-kpi--active': tab == TABS.PENDING }" @click="setTab(TABS.PENDING)">
          <span class="cheques-kpi__icon"><AppIcon name="hourglass_top" /></span>
          <span class="cheques-kpi__body"><small>Pendiente de acreditación</small><strong>{{ formatCurrency(summary.pending.amount) }}</strong><span>{{ summary.pending.deposits }} {{ summary.pending.deposits == 1 ? 'depósito' : 'depósitos' }} · {{ summary.pending.cheques }} {{ summary.pending.cheques == 1 ? 'cheque' : 'cheques' }}</span></span>
        </button>
        <button type="button" class="cheques-kpi cheques-kpi--expiring" @click="showExpiring" v-b-tooltip.hover.bottom title="Ver los cheques en cartera que vencen en los próximos 15 días">
          <span class="cheques-kpi__icon"><AppIcon name="event_upcoming" /></span>
          <span class="cheques-kpi__body"><small>Vencen en 15 días</small><strong>{{ formatCurrency(summary.expiring.amount) }}</strong><span>{{ summary.expiring.count }} {{ summary.expiring.count == 1 ? 'cheque' : 'cheques' }} en cartera</span></span>
        </button>
        <button type="button" class="cheques-kpi cheques-kpi--rejected" :class="{ 'cheques-kpi--active': tab == TABS.REJECTED }" @click="setTab(TABS.REJECTED)">
          <span class="cheques-kpi__icon"><AppIcon name="block" /></span>
          <span class="cheques-kpi__body"><small>Rechazados pendientes</small><strong>{{ formatCurrency(summary.rejected.amount || 0) }}</strong><span>{{ summary.rejected.count }} {{ summary.rejected.count == 1 ? 'cheque' : 'cheques' }} sin resolver</span></span>
        </button>
      </div>

      <b-nav tabs class="cheques-tabs">
        <b-nav-item :active="tab == TABS.PORTFOLIO" @click="setTab(TABS.PORTFOLIO)"><AppIcon name="account_balance_wallet" class="mr-1" /> Cartera</b-nav-item>
        <b-nav-item :active="tab == TABS.PENDING" @click="setTab(TABS.PENDING)">
          <AppIcon name="hourglass_top" class="mr-1" /> Depósitos pendientes
          <b-badge v-if="summary.pending.deposits" variant="warning" pill class="ml-1">{{ summary.pending.deposits }}</b-badge>
        </b-nav-item>
        <b-nav-item :active="tab == TABS.CREDITED" @click="setTab(TABS.CREDITED)"><AppIcon name="check_circle" class="mr-1" /> Acreditados</b-nav-item>
        <b-nav-item :active="tab == TABS.DELIVERED" @click="setTab(TABS.DELIVERED)"><AppIcon name="output" class="mr-1" /> Entregados</b-nav-item>
        <b-nav-item :active="tab == TABS.REJECTED" @click="setTab(TABS.REJECTED)">
          <AppIcon name="block" class="mr-1" /> Rechazados
          <b-badge v-if="summary.rejected && summary.rejected.count" variant="danger" pill class="ml-1">{{ summary.rejected.count }}</b-badge>
        </b-nav-item>
        <b-nav-item :active="tab == TABS.ALL" @click="setTab(TABS.ALL)"><AppIcon name="list" class="mr-1" /> Todos</b-nav-item>
      </b-nav>

      <div v-show="tab == TABS.PENDING" class="cheques-tab-pending">
        <ChequesDeposits ref="deposits" @changed="reloadAll" />
      </div>

      <ChequesRejections ref="rejections" @changed="onRejectionsChanged" />

      <b-card no-body class="cheques-detail-movimientos" v-show="tab != TABS.PENDING">
            <b-table class="app-table cheques-table mb-0"
                    responsive
                    sticky-header="60vh"
                    :hover="true"
                    :stacked="isMobileViewport ? 'md' : false"
                    :fixed="!isMobileViewport"
                    :items="table.items"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :tbody-tr-class="rowClass"
                    @row-clicked="onRowClicked"
                    v-if="table.items.length">                       
                  
                <template v-slot:table-colgroup="scope">
                  <col
                    v-for="field in scope.fields"                    
                    :key="field.key"
                    :style="{ width: field.width }"
                  >
                </template> 

                <template v-slot:head(select)>
                  <b-form-checkbox size="sm" :checked="allSelected" :disabled="!selectableItems.length" @change="toggleSelectAll" />
                </template>

                <template v-slot:cell(select)="data">
                  <b-form-checkbox v-if="data.item.status == 'PORTFOLIO'" size="sm" v-model="selected" :value="data.item.id" />
                </template>

                <template v-slot:cell(origen)="data">
                  <div v-if="hasOrigen(data.item)" :id="'origen-extra-'+data.item.id" style="cursor: pointer;" v-b-tooltip.hover.bottom :title="data.item.origen.customer">
                    {{ data.item.origen.customer }}
                  </div>
                  <b-popover v-if="hasOrigen(data.item)" :target="'origen-extra-'+data.item.id" triggers="hover" placement="top">
                    <template #title>Datos de Origen</template>

                    <span v-if="data.item.origen.point_sale">
                      {{data.item.origen.types_vouchers}} <br>
                      {{data.item.origen.point_sale.toString().padStart(4,'0') + '-' + data.item.origen.number.toString().padStart(8,'0')}} 
                      <hr>
                      {{moment(data.item.origen.date).format('DD MMMM YYYY')}} <br>
                      ({{data.item.origen.customer_id}}) - {{data.item.origen.customer}} 
                      <hr>
                      {{ data.item.origen.observations }}                      
                    </span>
                  </b-popover>                  
                </template>

                <template v-slot:cell(date)="data">
                  <div v-if="data.item.date">
                    {{ moment(data.item.date).format('DD MMMM YYYY') }}
                  </div>
                </template>

                <template v-slot:cell(days)="data">
                  <div v-if="data.item.date && data.item.date_expiration">
                    {{ moment(data.item.date_expiration).diff(moment(), 'days') }}
                  </div>
                </template>

                <template v-slot:cell(date_expiration)="data">
                  <div v-if="data.item.date_expiration">
                    <b>{{ moment(data.item.date_expiration).format('DD MMMM YYYY') }}</b>
                  </div>
                </template>

                <template v-slot:cell(cheque)="data">
                  <div class="cheques-cell-main" v-b-tooltip.hover.bottom :title="data.item.bank + ' · ' + data.item.number">
                    <strong>{{ data.item.bank }}</strong>
                    <span>N.º {{ data.item.number }}</span>
                  </div>
                  <div class="cheques-cell-meta" v-if="data.item.nd || data.item.observations || data.item.cancellations_count">
                    <span v-if="data.item.cancellations_count" class="cheques-history-chip" v-b-tooltip.hover.bottom title="Ver historial del cheque" @click.stop="openDetail(data.item)"><AppIcon name="history" /> {{ data.item.cancellations_count }} {{ data.item.cancellations_count == 1 ? 'anulación' : 'anulaciones' }}</span>
                    <b-badge v-if="data.item.nd" variant="secondary" v-b-tooltip.hover.bottom title="Cheque no declarado">No declarado</b-badge>
                    <span v-if="data.item.observations" class="cheques-observations-chip" v-b-tooltip.hover.bottom :title="data.item.observations"><AppIcon name="chat" /> Observación</span>
                  </div>
                </template>

                <template v-slot:cell(dates)="data">
                  <div class="cheques-cell-main"><strong>Vto. {{ moment(data.item.date_expiration).format('DD/MM/YYYY') }}</strong><span class="cheques-cell-secondary">Emisión {{ moment(data.item.date).format('DD/MM/YYYY') }}</span></div>
                  <span class="cheques-pill" :class="'cheques-pill--' + expiration(data.item).tone" v-b-tooltip.hover.bottom :title="expiration(data.item).hint"><AppIcon :name="expiration(data.item).icon" /> {{ expiration(data.item).text }}</span>
                </template>

                <template v-slot:cell(status)="data">
                  <span class="cheques-status" :class="'cheques-status--' + statusOf(data.item).tone"><AppIcon :name="statusOf(data.item).icon" /> {{ statusOf(data.item).text }}</span>
                </template>

                <template v-slot:cell(circuit)="data">
                  <div class="cheques-circuit-row" v-if="hasOrigen(data.item)" :id="'origen-circuit-'+data.item.id" v-b-tooltip.hover.bottom :title="data.item.origen.customer"><span>Origen</span><strong>{{ data.item.origen.customer }}</strong></div>
                  <b-popover v-if="hasOrigen(data.item)" :target="'origen-circuit-'+data.item.id" triggers="hover" placement="top"><template #title>Datos de origen</template><span v-if="data.item.origen.point_sale">{{ data.item.origen.types_vouchers }}<br>{{ data.item.origen.point_sale.toString().padStart(4,'0') + '-' + data.item.origen.number.toString().padStart(8,'0') }}<hr>{{ moment(data.item.origen.date).format('DD MMMM YYYY') }}<br>({{ data.item.origen.customer_id }}) - {{ data.item.origen.customer }}<hr>{{ data.item.origen.observations }}</span></b-popover>
                  <div class="cheques-circuit-row" v-if="data.item.destino && data.item.destino.type == 'DEPOSIT'" v-b-tooltip.hover.bottom :title="depositTitle(data.item.destino) + ' · Ver movimientos de la cuenta'"><span>Depósito</span><b-link class="cheques-cash-link" @click.stop="goToCashDetail(data.item.destino)">{{ data.item.destino.cash }}</b-link></div>
                  <span class="cheques-cell-secondary" v-if="!hasOrigen(data.item) && !(data.item.destino && (data.item.destino.type || data.item.destino.supplier))">Carga manual</span>
                  <div class="cheques-circuit-row" v-if="data.item.destino && data.item.destino.supplier" :id="'destino-circuit-'+data.item.id" v-b-tooltip.hover.bottom :title="data.item.destino.supplier"><span>Destino</span><strong>{{ data.item.destino.supplier }}</strong></div>
                  <b-popover v-if="data.item.destino && data.item.destino.supplier" :target="'destino-circuit-'+data.item.id" triggers="hover" placement="top"><template #title>Datos de destino</template><span v-if="data.item.destino.point_sale">{{ data.item.destino.types_vouchers }}<br>{{ data.item.destino.point_sale.toString().padStart(4,'0') + '-' + data.item.destino.number.toString().padStart(8,'0') }}<hr>{{ moment(data.item.destino.date).format('DD MMMM YYYY') }}<br>({{ data.item.destino.supplier_id }}) - {{ data.item.destino.supplier }}<hr>{{ data.item.destino.observations }}</span></b-popover>
                </template>

                <template v-slot:cell(bank)="data">
                  <span v-b-tooltip.hover.bottom :title="data.item.bank">{{ data.item.bank }}</span>
                </template>

                <template v-slot:cell(number)="data">
                  <span v-b-tooltip.hover.bottom :title="data.item.number">{{ data.item.number }}</span>
                </template>

                <template v-slot:cell(amount)="data">
                  <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(data.item.amount)}}</b>
                </template>

                <template v-slot:cell(transmitter)="data">
                  <div class="cheques-cell-main" v-b-tooltip.hover.bottom :title="data.item.transmitter_name + (data.item.transmitter_documents_number ? ' · CUIT ' + data.item.transmitter_documents_number : '')">
                    <strong v-if="data.item.transmitter_name">{{ data.item.transmitter_name }}</strong>
                    <span v-if="data.item.transmitter_documents_number">CUIT {{ data.item.transmitter_documents_number }}</span>
                  </div>
                </template>

                <template v-slot:cell(observations)="data">
                  <div v-if="data.item.observations" v-b-tooltip.hover.bottom :title="data.item.observations">
                    <span v-if="isMobileViewport">{{ data.item.observations }}</span>
                    <AppIcon v-else name="chat" />
                  </div>                                      
                </template>

                <template v-slot:cell(nd)="data">
                  <b-badge v-if="data.item.nd">SI</b-badge>            
                </template>   


                <template v-slot:cell(destino)="data">                                    
                  <div v-if="data.item.destino && data.item.destino.type == 'DEPOSIT'">
                    Depósito: {{ data.item.destino.cash }}
                  </div>
                  <div v-if="data.item.destino && data.item.destino.supplier" :id="'destino-extra-'+data.item.id" style="cursor: pointer;" v-b-tooltip.hover.bottom :title="data.item.destino.supplier">
                    {{ data.item.destino.supplier }}
                  </div>
                  <b-popover v-if="data.item.destino && data.item.destino.supplier" :target="'destino-extra-'+data.item.id" triggers="hover" placement="top">
                    <template #title>Datos de Destino</template>                    

                    <span v-if="data.item.destino.point_sale">
                      {{data.item.destino.types_vouchers}} <br>
                      {{data.item.destino.point_sale.toString().padStart(4,'0') + '-' + data.item.destino.number.toString().padStart(8,'0')}} 
                      <hr>
                      {{moment(data.item.destino.date).format('DD MMMM YYYY')}} <br>
                      ({{data.item.destino.supplier_id}}) - {{data.item.destino.supplier}} 
                      <hr>
                      {{ data.item.destino.observations }}
                    </span>
                  </b-popover>                  
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window" :toggle-class="isMobileViewport ? 'cheques-action-toggle-labeled' : 'app-table-action-toggle'" :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content><AppIcon name="more_vert" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>
                    <b-dropdown-item @click="openDetail(data.item)">
                      <AppIcon name="visibility" class="mr-1" /> Visualizar
                    </b-dropdown-item>
                    <b-dropdown-divider />
                    <b-dropdown-header v-if="data.item.accounting_locks && Object.keys(data.item.accounting_locks).length" :title="Object.values(data.item.accounting_locks)[0]">Acciones limitadas por Contabilidad</b-dropdown-header>
                    <b-dropdown-item @click="depositOne(data.item)" v-if="data.item.status == 'PORTFOLIO'">
                      <AppIcon name="account_balance" class="mr-1" /> Depositar
                    </b-dropdown-item>
                    <b-dropdown-item @click="cancelDeposit(data.item)" v-if="data.item.status == 'DEPOSITED' && !chequeLock(data.item, 'deposit')">
                      <AppIcon name="undo" class="mr-1" /> Anular depósito
                    </b-dropdown-item>
                    <b-dropdown-item @click="$refs.deposits.revert(data.item.destino.deposit_id)" v-if="data.item.status == 'CREDITED' && !chequeLock(data.item, 'deposit')">
                      <AppIcon name="undo" class="mr-1 text-danger" /> Revertir acreditación
                    </b-dropdown-item>
                    <b-dropdown-item @click="$refs.rejections.reject(data.item)" v-if="['DEPOSITED', 'CREDITED', 'DELIVERED'].includes(data.item.status)">
                      <AppIcon name="block" class="mr-1 text-danger" /> Registrar rechazo
                    </b-dropdown-item>
                    <template v-if="data.item.status == 'REJECTED' && data.item.rejection">
                      <template v-if="!rejectionResolved(data.item)">
                        <b-dropdown-item @click="$refs.rejections.generateDebitNote(data.item)" v-if="hasOrigen(data.item)">
                          <AppIcon name="receipt_long" class="mr-1" /> Generar nota de débito
                        </b-dropdown-item>
                        <b-dropdown-item @click="$refs.rejections.linkDebitNote(data.item)" v-if="hasOrigen(data.item)">
                          <AppIcon name="link" class="mr-1" /> Vincular nota de débito
                        </b-dropdown-item>
                        <b-dropdown-item @click="$refs.rejections.resolve(data.item)" v-if="!chequeLock(data.item, 'rejection_change')">
                          <AppIcon name="task_alt" class="mr-1" /> Marcar como resuelto
                        </b-dropdown-item>
                        <b-dropdown-item @click="$refs.rejections.returnToPortfolio(data.item)" v-if="!chequeLock(data.item, 'rejection_change')">
                          <AppIcon name="undo" class="mr-1" /> Volver a cartera
                        </b-dropdown-item>
                        <b-dropdown-item @click="$refs.rejections.cancel(data.item)" v-if="!chequeLock(data.item, 'rejection_cancel')">
                          <AppIcon name="delete" class="mr-1 text-danger" /> Anular rechazo
                        </b-dropdown-item>
                      </template>
                      <b-dropdown-item @click="$refs.rejections.unlinkDebitNote(data.item)" v-if="data.item.rejection.sales_id && !chequeLock(data.item, 'rejection_unlink')">
                        <AppIcon name="link_off" class="mr-1" /> Desvincular nota de débito
                      </b-dropdown-item>
                      <b-dropdown-item @click="$refs.rejections.reopen(data.item)" v-if="data.item.rejection.resolved_at">
                        <AppIcon name="replay" class="mr-1" /> Reabrir rechazo
                      </b-dropdown-item>
                    </template>
                    <b-dropdown-divider v-if="data.item.status == 'PORTFOLIO'" />
                    <b-dropdown-item @click="edit(data.item)" v-if="data.item.status == 'PORTFOLIO'">
                      <AppIcon name="edit" class="mr-1" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)" v-if="canDelete(data.item)">
                      <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="receipt_long" title="No se encontraron cheques" />
            <div class="app-table-footer cheques-table-footer" v-if="table.items.length"><span>{{ getRowCount(table.items) }} registros · Total <strong>{{ formatCurrency(getAmountResumen()) }}</strong></span></div>
      </b-card>

      <b-card body-class="py-2" class="mt-2 cheques-page-footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" class="mr-1" />
              Volver
            </b-button>                        
          </b-col>

          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(table.items)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col>          
        </b-row>
      </b-card>

      <!-- DRAWER: detalle e historial del cheque seleccionado -->
      <b-sidebar v-model="detailDrawer" right shadow backdrop title="Detalle del cheque" width="420px" @hidden="hideDetail">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code">{{ itemSelected.bank }} N.º {{ itemSelected.number }}</span>
              <div>{{ itemSelected.transmitter_name || 'Sin emisor' }}</div>
              <div class="list-view-drawer__meta">
                <span v-if="itemSelected.transmitter_documents_number">CUIT {{ itemSelected.transmitter_documents_number }}</span>
              </div>
              <span class="cheques-status mt-1" :class="'cheques-status--' + statusOf(itemSelected).tone"><AppIcon :name="statusOf(itemSelected).icon" /> {{ statusOf(itemSelected).text }}</span>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm" variant="outline-secondary" :disabled="!canGoPrevDetail" v-b-tooltip.hover title="Cheque anterior" @click="goPrevDetail"><AppIcon name="chevron-up" label="Cheque anterior" /></b-button>
              <b-button size="sm" variant="outline-secondary" :disabled="!canGoNextDetail" v-b-tooltip.hover title="Cheque siguiente" @click="goNextDetail"><AppIcon name="chevron-down" label="Cheque siguiente" /></b-button>
            </div>
          </div>

          <div class="list-view-drawer__stats">
            <div class="list-view-drawer__stat">
              <span class="list-view-drawer__stat-label">Importe</span>
              <span class="list-view-drawer__stat-value">{{ formatCurrency(itemSelected.amount) }}</span>
            </div>
            <div class="list-view-drawer__stat" :class="{ 'list-view-drawer__stat--warning': ['warning', 'danger'].includes(expiration(itemSelected).tone) }">
              <span class="list-view-drawer__stat-label">Vencimiento</span>
              <span class="list-view-drawer__stat-value">{{ moment(itemSelected.date_expiration).format('DD/MM/YYYY') }}</span>
              <span class="cheques-cell-secondary">{{ expiration(itemSelected).text }}<template v-if="expiration(itemSelected).hint"> · {{ expiration(itemSelected).hint }}</template></span>
            </div>
          </div>

          <div>
            <div class="list-view-drawer__section-title"><AppIcon name="receipt_long" /> Datos</div>
            <dl class="cheques-detail-list">
              <dt>Emisión</dt><dd>{{ moment(itemSelected.date).format('DD/MM/YYYY') }}</dd>
              <dt>Condición</dt><dd>{{ itemSelected.nd ? 'No declarado' : 'Declarado' }}</dd>
              <template v-if="itemSelected.observations"><dt>Observaciones</dt><dd>{{ itemSelected.observations }}</dd></template>
            </dl>
          </div>

          <div>
            <div class="list-view-drawer__section-title"><AppIcon name="swap_horiz" /> Circuito</div>
            <dl class="cheques-detail-list">
              <dt>Origen</dt>
              <dd v-if="hasOrigen(itemSelected)">
                {{ itemSelected.origen.types_vouchers }} {{ itemSelected.origen.point_sale ? itemSelected.origen.point_sale.toString().padStart(4,'0') + '-' + itemSelected.origen.number.toString().padStart(8,'0') : '' }}
                <div class="cheques-cell-secondary">{{ itemSelected.origen.customer }}</div>
              </dd>
              <dd v-else>Carga manual</dd>
              <template v-if="itemSelected.destino && itemSelected.destino.type == 'DEPOSIT'">
                <dt>Depósito</dt>
                <dd><b-link class="cheques-cash-link" v-b-tooltip.hover title="Ver movimientos de la cuenta" @click="goToCashDetail(itemSelected.destino)">{{ itemSelected.destino.cash }} <AppIcon name="open_in_new" /></b-link> <span class="cheques-cell-secondary">#{{ itemSelected.destino.deposit_id }}</span>
                  <div class="cheques-cell-secondary">{{ depositTitle(itemSelected.destino) }}</div>
                </dd>
              </template>
              <template v-if="itemSelected.destino && itemSelected.destino.supplier">
                <dt>Destino</dt>
                <dd>
                  {{ itemSelected.destino.types_vouchers }} {{ itemSelected.destino.point_sale ? itemSelected.destino.point_sale.toString().padStart(4,'0') + '-' + itemSelected.destino.number.toString().padStart(8,'0') : '' }}
                  <div class="cheques-cell-secondary">{{ itemSelected.destino.supplier }}</div>
                </dd>
              </template>
            </dl>
          </div>

          <div v-if="itemSelected.status == 'REJECTED' && itemSelected.rejection">
            <div class="list-view-drawer__section-title"><AppIcon name="block" /> Rechazo</div>
            <dl class="cheques-detail-list">
              <dt>Fecha</dt><dd>{{ moment(itemSelected.rejection.date).format('DD/MM/YYYY') }}</dd>
              <dt>Motivo</dt><dd>{{ itemSelected.rejection.reason_name }}<div class="cheques-cell-secondary" v-if="itemSelected.rejection.observations">{{ itemSelected.rejection.observations }}</div></dd>
              <dt>Origen</dt><dd>{{ itemSelected.rejection.origin == 'PAYMENT' ? 'Devuelto por el proveedor' : 'Rechazado por el banco' }}</dd>
              <template v-if="parseFloat(itemSelected.rejection.amount_expenses) > 0">
                <dt>Gastos</dt>
                <dd>
                  {{ formatCurrency(itemSelected.rejection.amount_expenses) }}
                  <div v-for="expense in itemSelected.rejection.expenses" :key="expense.id" class="cheques-cell-secondary">
                    {{ expense.bank_type_name }}: {{ formatCurrency(expense.amount) }}
                    <template v-if="expense.purchase_link">
                      <span v-if="expense.purchase_link.status == 'PENDING'" class="text-warning"><AppIcon name="warning" /> Falta comprobante (se carga desde Movimientos de la cuenta)</span>
                      <span v-else><AppIcon name="receipt_long" /> {{ expense.purchase_link.reference }}</span>
                    </template>
                  </div>
                </dd>
              </template>
              <dt>Nota de débito</dt>
              <dd>
                <template v-if="itemSelected.rejection.sales_id && !chequeLock(itemSelected, 'rejection_unlink')">
                  {{ itemSelected.rejection.sales_reference || 'Vinculada' }}
                </template>
                <template v-else-if="itemSelected.rejection.resolved_at">No corresponde (resuelto)</template>
                <template v-else-if="hasOrigen(itemSelected)">Sin emitir</template>
                <template v-else>No aplica (carga manual)</template>
              </dd>
              <template v-if="itemSelected.rejection.resolved_at">
                <dt>Resolución</dt>
                <dd>
                  {{ itemSelected.rejection.resolution_reason_name }}
                  <div class="cheques-cell-secondary">
                    {{ moment(itemSelected.rejection.resolved_at).format('DD/MM/YYYY HH:mm') }}<template v-if="itemSelected.rejection.resolution_observations"> · {{ itemSelected.rejection.resolution_observations }}</template>
                  </div>
                </dd>
              </template>
            </dl>
          </div>

          <div>
            <div class="list-view-drawer__section-title"><AppIcon name="history" /> Historial</div>
            <div v-if="history.loading" class="cheques-cell-secondary">Cargando historial…</div>
            <ol v-else-if="history.events.length" class="cheques-timeline">
              <li v-for="(event, index) in history.events" :key="index" class="cheques-timeline__item" :class="'cheques-timeline__item--' + event.tone">
                <span class="cheques-timeline__dot"><AppIcon :name="event.icon" /></span>
                <div class="cheques-timeline__body">
                  <strong>{{ event.title }}</strong>
                  <span v-if="event.description">{{ event.description }}</span>
                  <small>{{ moment(event.at).format(event.date_only ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm') }}<template v-if="event.user"> · {{ event.user }}</template></small>
                </div>
              </li>
            </ol>
            <div v-else class="cheques-cell-secondary">Sin movimientos registrados.</div>
          </div>

          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" v-if="itemSelected.status == 'PORTFOLIO'" @click="depositOne(itemSelected)"><AppIcon name="account_balance" class="mr-1" /> Depositar</b-button>
            <b-button size="sm" variant="outline-secondary" v-if="itemSelected.status == 'DEPOSITED' && !chequeLock(itemSelected, 'deposit')" @click="cancelDeposit(itemSelected)"><AppIcon name="undo" class="mr-1" /> Anular depósito</b-button>
            <b-button size="sm" variant="outline-secondary" v-if="itemSelected.status == 'CREDITED' && !chequeLock(itemSelected, 'deposit')" @click="$refs.deposits.revert(itemSelected.destino.deposit_id)"><AppIcon name="undo" class="mr-1" /> Revertir acreditación</b-button>
            <b-button size="sm" variant="outline-secondary" v-if="['DEPOSITED', 'CREDITED', 'DELIVERED'].includes(itemSelected.status)" @click="$refs.rejections.reject(itemSelected)"><AppIcon name="block" class="mr-1" /> Registrar rechazo</b-button>
            <template v-if="itemSelected.status == 'REJECTED' && itemSelected.rejection">
              <template v-if="!rejectionResolved(itemSelected)">
                <b-button size="sm" variant="outline-secondary" v-if="hasOrigen(itemSelected)" @click="$refs.rejections.generateDebitNote(itemSelected)"><AppIcon name="receipt_long" class="mr-1" /> Generar nota de débito</b-button>
                <b-button size="sm" variant="outline-secondary" v-if="hasOrigen(itemSelected)" @click="$refs.rejections.linkDebitNote(itemSelected)"><AppIcon name="link" class="mr-1" /> Vincular nota de débito</b-button>
                <b-button size="sm" variant="outline-secondary" @click="$refs.rejections.resolve(itemSelected)" v-if="!chequeLock(itemSelected, 'rejection_change')"><AppIcon name="task_alt" class="mr-1" /> Marcar como resuelto</b-button>
                <b-button size="sm" variant="outline-secondary" @click="$refs.rejections.returnToPortfolio(itemSelected)" v-if="!chequeLock(itemSelected, 'rejection_change')"><AppIcon name="undo" class="mr-1" /> Volver a cartera</b-button>
                <b-button size="sm" variant="outline-danger" @click="$refs.rejections.cancel(itemSelected)" v-if="!chequeLock(itemSelected, 'rejection_cancel')"><AppIcon name="delete" class="mr-1" /> Anular rechazo</b-button>
              </template>
              <b-button size="sm" variant="outline-secondary" v-if="itemSelected.rejection.sales_id && !chequeLock(itemSelected, 'rejection_unlink')" @click="$refs.rejections.unlinkDebitNote(itemSelected)"><AppIcon name="link_off" class="mr-1" /> Desvincular nota de débito</b-button>
              <b-button size="sm" variant="outline-secondary" v-if="itemSelected.rejection.resolved_at && !chequeLock(itemSelected, 'rejection_reopen')" @click="$refs.rejections.reopen(itemSelected)"><AppIcon name="replay" class="mr-1" /> Reabrir rechazo</b-button>
            </template>
            <b-button size="sm" variant="outline-secondary" v-if="itemSelected.status == 'PORTFOLIO'" @click="edit(itemSelected)"><AppIcon name="edit" class="mr-1" /> Editar</b-button>
          </div>
        </div>

        <template #footer>
          <div class="list-view-drawer__footer" v-if="itemSelected && canDelete(itemSelected)">
            <b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)"><AppIcon name="delete" class="mr-1" /> Eliminar</b-button>
          </div>
        </template>
      </b-sidebar>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <ChequeFormModal ref="chequeForm"
                       @saved="reloadAll()" />
      <!-- DEPOSITAR -->
      <ChequeDepositModal ref="chequeDeposit"
                          @saved="onDepositSaved()" />
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import ModuleViewHeading from '@/components/inc/module/ModuleViewHeading'
  import Helper from '@/handler/helper' 
  import moment from 'moment'
  import Storage from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import ChequeFormModal from './inc/ChequeFormModal'
  import ChequeDepositModal from './inc/ChequeDepositModal'
  import ChequesDeposits from './inc/chequesDeposits'
  import ChequesRejections from './inc/chequesRejections'

  const TABS = { PORTFOLIO: 'portfolio', PENDING: 'pending', CREDITED: 'credited', DELIVERED: 'delivered', REJECTED: 'rejected', ALL: 'all' }

  // estado que filtra cada pestaña de listado (Todos usa el filtro Estado)
  const TAB_STATUS = { portfolio: 'PORTFOLIO', credited: 'CREDITED', delivered: 'DELIVERED', rejected: 'REJECTED' }

  // estados del cheque (FinancesCheques.status)
  const CHEQUE_STATUS = {
    PORTFOLIO: { text: 'En cartera', icon: 'account_balance_wallet', tone: 'success' },
    DELIVERED: { text: 'Entregado', icon: 'output', tone: 'neutral' },
    DEPOSITED: { text: 'Pend. acreditación', icon: 'hourglass_top', tone: 'warning' },
    CREDITED: { text: 'Acreditado', icon: 'check_circle', tone: 'primary' },
    REJECTED: { text: 'Rechazado', icon: 'block', tone: 'danger' },
    REJECTED_DEBITED: { text: 'Rechazado · ND emitida', icon: 'receipt_long', tone: 'neutral' },
    REJECTED_RESOLVED: { text: 'Rechazado · resuelto', icon: 'task_alt', tone: 'neutral' },
  }

  export default {
    components: {
      ModuleViewHeading,
      TabHeaderActions,
      ChequeFormModal,
      ChequeDepositModal,
      ChequesDeposits,
      ChequesRejections,
    },
    data: () => {
      return {      
        Modules,
        Profiles,
        access: {
          module_id: Modules.FINANZAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'cheques',
          elements: {}
        },  
        table : {
          items: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 50,
        },      
        crud: {
          form: {
            id: 0,
            number: '',
          },
        },
        modal: {
        },
        arr: {
          filters : {
            available: [
              {code: 'PORTFOLIO', label: 'En cartera'},
              {code: 'DELIVERED', label: 'Entregado (orden de pago)'},
              {code: 'DEPOSITED', label: 'Depositado, pendiente de acreditación'},
              {code: 'CREDITED', label: 'Depositado y acreditado'},
              {code: 'REJECTED', label: 'Rechazado, pendiente de nota de débito'},
              {code: 'REJECTED_RESOLVED', label: 'Rechazado resuelto (con ND o resuelto por fuera)'},
            ]
          },                       
        },        
        selected: [],
        detailDrawer: false,
        itemSelected: null,
        history: {
          loading: false,
          events: [],
        },
        filters: {
          date_start: '',
          date_end: '',
          available: null,
        },
        TABS,
        tab: TABS.PORTFOLIO,
        summary: {
          portfolio: { amount: 0, count: 0 },
          pending: { amount: 0, deposits: 0, cheques: 0 },
          expiring: { amount: 0, count: 0 },
          rejected: { count: 0, amount: 0 },
        },
        filtersOpen: false,
        isMobileViewport: false,
        mobileMql: null,
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.filtersOpen = Storage.getValue('filters_open_cheques') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadFieldTable()
      this.loadSummary()
      this.$refs.chequeDeposit.loadCash()

      this.restoreFilterStorage() 
      this.filterLoad()

      this.load()

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 

      this.loadSummary()
      this.filterLoad()
      this.load()        
      this.$refs.chequeDeposit.loadCash()
      this.$refs.deposits.load()
    },         
    computed: {
      getCurrencyCode() {
        return 'ARS'
      },
      currentDetailIndex() {
        if(!this.itemSelected) return -1
        return this.table.items.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrevDetail() {
        return this.currentDetailIndex > 0
      },
      canGoNextDetail() {
        return this.currentDetailIndex >= 0 && this.currentDetailIndex < this.table.items.length - 1
      },
      listingRejected() {
        if(this.tab == TABS.REJECTED) return true
        const code = this.tab == TABS.ALL && this.filters.available ? this.filters.available.code : null
        return ['REJECTED', 'REJECTED_RESOLVED', 'REJECTED_DEBITED'].includes(code)
      },
      selectableItems() {
        return this.table.items.filter(item => item.status == 'PORTFOLIO')
      },
      allSelected() {
        return this.selectableItems.length > 0 && this.selectableItems.every(item => this.selected.includes(item.id))
      },
    },
    watch: {
      filtersOpen(value) {
        Storage.setValue('filters_open_cheques', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      loadFieldTable() {
        if(!this.isMobileViewport) {
          this.table.fields = [
            {key: 'select', label: '', class: 'align-middle text-center', width:'3%', portfolioOnly: true},
            {key: 'id', label: 'ID', class: 'align-middle text-center font-weight-bold', width:'5%'},
            {key: 'cheque', label: 'Cheque', class: 'align-middle', width:'15%'},
            {key: 'dates', label: 'Vencimiento', class: 'align-middle', width:'15%'},
            {key: 'transmitter', label: 'Emisor', class: 'align-middle', width:'20%'},
            {key: 'circuit', label: 'Origen / destino', class: 'align-middle', width:'19%'},
            {key: 'status', label: 'Estado', class: 'align-middle', width:'11%'},
            {key: 'amount', label: 'Importe', class: 'align-middle text-right', width:'10%'},
            {key: 'f_action', label: '', class: 'align-middle', width:'2%'},
          ].filter(this.fieldForTab)
          return
        }
        this.table.fields = [
          {key: 'select', label: 'Seleccionar', class: 'align-middle', width:'3%', portfolioOnly: true},
          {key: 'id', label: 'ID', class: 'align-middle font-weight-bold ' + this.alignClass('text-center'), width:'3%'},
          {key: 'origen', label: 'Origen', class: 'align-middle', width:'8%'},
          {key: 'bank', label: 'Banco', class: 'align-middle', width:'8%'},
          {key: 'number', label: 'Número', class: 'align-middle ' + this.alignClass('text-center'), width:'8%'},
          {key: 'date', label: 'Fecha', class: 'align-middle ' + this.alignClass('text-center'), width:'8%'},
          {key: 'date_expiration', label: 'Vencimiento', class: 'align-middle ' + this.alignClass('text-center'), width:'10%'},
          {key: 'days', label: 'Días', class: 'align-middle ' + this.alignClass('text-center'), width:'5%'},
          {key: 'status', label: 'Estado', class: 'align-middle', width:'8%'},
          {key: 'transmitter', label: 'Emisor', class: 'align-middle', width:'20%'},
          {key: 'amount', label: 'Importe', class: 'align-middle ' + this.alignClass('text-right'), width:'10%'},
          {key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class: 'align-middle ' + this.alignClass('text-center'), width:'5%'},
          {key: 'nd', label: 'ND', class:'align-middle', width:'5%'},
          {key: 'destino', label: 'Destino', class: 'align-middle', width:'8%'},
        ].filter(this.fieldForTab)
      },
      // la selección (para depositar) solo aplica en la pestaña Cartera
      fieldForTab(field) {
        return !field.portfolioOnly || this.tab == TABS.PORTFOLIO
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      getRowCount (items) {
        return items.length
      },
      // Cartera y Rechazados: todo lo que está en la mano (sin rango).
      // Acreditados y Entregados: vencimientos de hace 30 días a dentro de 30. Todos: próximos 30 días.
      filterLoad() {
        if(this.tab == TABS.ALL) {
          this.filters.date_start = moment().format('YYYY-MM-DD')
          this.filters.date_end = moment().add(30, 'days').format('YYYY-MM-DD')
        } else if(this.tab == TABS.CREDITED || this.tab == TABS.DELIVERED) {
          this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD')
          this.filters.date_end = moment().add(30, 'days').format('YYYY-MM-DD')
        } else {
          this.filters.date_start = ''
          this.filters.date_end = ''
        }
      },
      load() {
        this.saveFilterStorage()    
        
        let loader = this.$loading.show()  
        
        // cada carga arranca en la primera página (la paginación de la tabla es local)
        this.table.currentPage = 1
        var params = Object.assign({}, this.filters)
        if(TAB_STATUS[this.tab]) {
          params.available = { code: TAB_STATUS[this.tab] }
        }
        // cartera y rechazados: todo lo que está en la mano, sin límite
        if(this.tab == TABS.PORTFOLIO || this.tab == TABS.REJECTED) {
          params.without_paginate = true
        }
        var result = serviceAPI.filtrarCheques(params, 1)        

        result.then((response) => {
          loader.hide()          
          this.table.items = response.data.data

          if(this.detailDrawer && this.itemSelected) {
            const fresh = this.table.items.find(item => item.id === this.itemSelected.id)
            if(fresh) {
              this.itemSelected = fresh
              this.loadHistory()
            } else {
              this.detailDrawer = false
            }
          }

          const portfolio = this.table.items.filter(item => item.status == 'PORTFOLIO').map(item => item.id)
          this.selected = this.selected.filter(id => portfolio.includes(id))
        })
        .catch(error => {                         
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });     
      },
      add() {
        this.$refs.chequeForm.add()
      },
      edit(item) {
        this.$refs.chequeForm.edit(item)
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.number = item.number 

        this.confirmDialog('¿Desea borrar el cheque ' + this.crud.form.number + '?', {
          title: 'Borrar cheque',
          icon: 'delete',
          danger: true,
          okTitle: 'Eliminar'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCheque(this.crud.form.id);

            result.then((response) => {      
              this.$refs.chequeForm.close()        
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      reloadAll() {
        this.load()
        this.loadSummary()
      },
      onRejectionsChanged() {
        this.reloadAll()
        this.$refs.deposits.load()
      },
      toggleSelectAll(checked) {
        this.selected = checked ? this.selectableItems.map(item => item.id) : []
      },
      depositSelected() {
        this.openDeposit(this.table.items.filter(item => this.selected.includes(item.id)))
      },
      depositOne(item) {
        this.openDeposit([item])
      },
      openDeposit(cheques) {
        this.$refs.chequeDeposit.open(cheques)
      },
      onDepositSaved() {
        this.selected = []
        this.reloadAll()
        this.$refs.deposits.load()
      },
      cancelDeposit(item) {
        this.$refs.deposits.cancelItem(
          { id: item.destino.item_id, amount: item.amount, finances_cheques_deposits_id: item.destino.deposit_id },
          null,
          item.bank + ' N.º ' + item.number
        )
      },
      chequeLock(item, action) {
        return item.accounting_locks ? item.accounting_locks[action] : null
      },
      hasOrigen(item) {
        return !!(item.origen && item.origen.customer)
      },
      // rechazo resuelto: con la ND emitida o marcado como resuelto por fuera
      rejectionResolved(item) {
        return !!(item.rejection && (item.rejection.sales_id || item.rejection.resolved_at))
      },
      statusOf(item) {
        // rechazado con la ND ya emitida: resuelto, el reclamo está en la cuenta corriente del cliente
        if(item.status == 'REJECTED' && item.rejection && item.rejection.sales_id) {
          return CHEQUE_STATUS.REJECTED_DEBITED
        }
        if(item.status == 'REJECTED' && item.rejection && item.rejection.resolved_at) {
          return CHEQUE_STATUS.REJECTED_RESOLVED
        }
        return CHEQUE_STATUS[item.status] || CHEQUE_STATUS.PORTFOLIO
      },
      rowClass(item, type) {
        if(!item || type !== 'row') return
        var classes = 'cheques-row cheques-row--' + this.statusOf(item).tone
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          classes += ' app-table-row-active'
        }
        return classes
      },
      // Eliminar: solo cheques cargados a mano, en cartera, sin depósitos que no sean anulaciones
      // (esas se borran en cascada) y sin OP. El backend lo valida igual (getRelationships);
      // acá se evita ofrecer una acción que fallaría.
      canDelete(item) {
        return item.status == 'PORTFOLIO'
            && !this.hasOrigen(item)
            && !((item.deposits_count || 0) - (item.cancellations_count || 0))
            && !(item.destino && item.destino.supplier)
      },

      // DRAWER DE DETALLE
      onRowClicked(item, index, event) {
        if(!item) return
        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown') || event.target.closest('.custom-control')) return
        }
        this.openDetail(item)
      },
      openDetail(item) {
        this.itemSelected = item
        this.detailDrawer = true
        this.loadHistory()
      },
      hideDetail() {
        this.itemSelected = null
        this.history.events = []
        this.detailDrawer = false
      },
      // Anterior/siguiente: reusa openDetail() con el vecino, igual que un click en la tabla.
      goPrevDetail() {
        if(!this.canGoPrevDetail) return
        this.openDetail(this.table.items[this.currentDetailIndex - 1])
      },
      goNextDetail() {
        if(!this.canGoNextDetail) return
        this.openDetail(this.table.items[this.currentDetailIndex + 1])
      },
      loadHistory() {
        const id = this.itemSelected.id
        this.history.loading = true
        serviceAPI.historialCheque(id)
        .then((response) => {
          // si se navegó a otro cheque mientras cargaba, se descarta
          if(!this.itemSelected || this.itemSelected.id !== id) return
          this.history.events = response.data
          this.history.loading = false
        })
        .catch(error => {
          this.history.loading = false
          this.$awn.alert(Error.showError(error))
        })
      },
      // Urgencia del vencimiento. En cartera, el cheque se puede depositar hasta
      // 30 días después del vencimiento.
      expiration(item) {
        const days = moment(item.date_expiration).startOf('day').diff(moment().startOf('day'), 'days')
        const label = days > 0 ? 'en ' + days + (days == 1 ? ' día' : ' días')
                    : days == 0 ? 'vence hoy'
                    : 'vencido hace ' + Math.abs(days) + (days == -1 ? ' día' : ' días')

        if(item.status != 'PORTFOLIO') return { tone: 'neutral', icon: 'event', text: label, hint: '' }

        if(days < -30) return { tone: 'danger', icon: 'block', text: label, hint: 'Superó el plazo de 30 días para depositarlo' }
        if(days <= -25) return { tone: 'danger', icon: 'warning', text: label, hint: 'Quedan ' + (30 + days) + ' días para depositarlo' }
        if(days <= 15) return { tone: 'warning', icon: 'schedule', text: label, hint: days < 0 ? 'Quedan ' + (30 + days) + ' días para depositarlo' : '' }
        return { tone: 'success', icon: 'event_available', text: label, hint: '' }
      },
      // Movimientos de la cuenta donde se depositó, desde la acreditación (o el depósito si está pendiente)
      goToCashDetail(destino) {
        this.detailDrawer = false
        this.$router.push({
          name: 'FinancesStaffCashDetail',
          params: { finances_cash_id: destino.cash_id, date_start: destino.date_credited || destino.date },
        }).catch(() => {})
      },
      depositTitle(destino) {
        let title = 'Depósito #' + destino.deposit_id + ' del ' + moment(destino.date).format('DD/MM/YYYY')
        if(destino.date_credited) title += ' · acreditado el ' + moment(destino.date_credited).format('DD/MM/YYYY')
        return title
      },

      loadSummary() {
        serviceAPI.resumenCheques()
        .then((response) => {
          this.summary = response.data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      formatCurrency(value) {
        return Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(value)
      },
      setTab(tab) {
        if(this.tab == tab) return
        this.tab = tab
        this.selected = []
        this.filterLoad()
        this.loadFieldTable()
        if(tab != TABS.PENDING) this.load()
      },
      // cheques en cartera que vencen en los próximos 15 días
      showExpiring() {
        this.filters.date_start = moment().format('YYYY-MM-DD')
        this.filters.date_end = moment().add(15, 'days').format('YYYY-MM-DD')
        this.filtersOpen = true
        this.tab = TABS.PORTFOLIO
        this.selected = []
        this.loadFieldTable()
        this.load()
      },
      getAmountResumen() {
        let total = 0
        this.table.items.forEach(element => {
          // los rechazados solo suman cuando el listado es de rechazados (su pestaña o el filtro en Todos)
          if(element.status == 'REJECTED' && !this.listingRejected) return
          total = total + parseFloat(element.amount)
        });
        
        return total
      },  

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_cash_cheques', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_cash_cheques')) {
          this.filters = JSON.parse(Storage.getValue('filter_cash_cheques'))
        }         
      },             
    }    
  }
</script>
<style scoped>
  .cheques-table-footer { padding-right: 12px; }
  .cheques-cash-link { color: var(--app-color-primary-active); font-weight: var(--app-font-semibold); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .cheques-cash-link:hover { color: var(--app-color-primary); }
  .cheques-cash-link .material-symbols-rounded { font-size: 14px; vertical-align: -2px; }
  .cheques-history-chip { align-items: center; background: var(--app-color-danger-soft); border-radius: 999px; color: var(--app-color-danger); cursor: pointer; display: inline-flex; font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); gap: 3px; padding: 2px 7px; }
  .cheques-history-chip .material-symbols-rounded { color: inherit; font-size: 14px; vertical-align: 0; }
  .cheques-detail-list { display: grid; gap: 6px 12px; grid-template-columns: 96px 1fr; margin: 0; }
  .cheques-detail-list dt { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); padding-top: 2px; }
  .cheques-detail-list dd { color: var(--app-color-text); margin: 0; }
  .cheques-timeline { list-style: none; margin: 0; padding: 0; }
  .cheques-timeline__item { display: flex; gap: 10px; padding-bottom: 14px; position: relative; }
  .cheques-timeline__item:not(:last-child)::before { background: var(--app-color-border-strong); bottom: 0; content: ''; left: 13px; position: absolute; top: 28px; width: 2px; }
  .cheques-timeline__dot { align-items: center; border: 1px solid; border-radius: 50%; display: inline-flex; flex: 0 0 28px; height: 28px; justify-content: center; }
  .cheques-timeline__dot .material-symbols-rounded { font-size: 16px; }
  .cheques-timeline__body { display: grid; gap: 1px; line-height: 1.35; min-width: 0; padding-top: 3px; }
  .cheques-timeline__body strong { color: var(--app-color-text); font-size: var(--app-text-sm); }
  .cheques-timeline__body span { color: var(--app-color-text); font-size: var(--app-text-xs); overflow-wrap: anywhere; }
  .cheques-timeline__body small { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); }
  .cheques-timeline__item--success .cheques-timeline__dot { background: var(--app-color-success-soft); border-color: var(--app-color-success-border); color: var(--app-color-success); }
  .cheques-timeline__item--warning .cheques-timeline__dot { background: var(--app-color-warning-soft); border-color: var(--app-color-warning-border); color: var(--app-color-warning-hover); }
  .cheques-timeline__item--primary .cheques-timeline__dot { background: var(--app-color-primary-soft); border-color: var(--app-color-info-border); color: var(--app-color-primary-active); }
  .cheques-timeline__item--danger .cheques-timeline__dot { background: var(--app-color-danger-soft); border-color: var(--app-color-danger-border); color: var(--app-color-danger); }
  .cheques-timeline__item--neutral .cheques-timeline__dot { background: var(--app-color-surface-subtle); border-color: var(--app-color-border-strong); color: var(--app-color-text-secondary); }
  .cheques-cell-secondary { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); }
  .cheques-pill { align-items: center; border: 1px solid; border-radius: 999px; display: inline-flex; font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); gap: 3px; line-height: 1.5; margin-top: 3px; padding: 1px 8px; white-space: nowrap; }
  .cheques-pill .material-symbols-rounded { font-size: 14px; }
  .cheques-pill--success { background: var(--app-color-success-soft); border-color: var(--app-color-success-border); color: var(--app-color-success); }
  .cheques-pill--warning { background: var(--app-color-warning-soft); border-color: var(--app-color-warning-border); color: var(--app-color-warning-hover); }
  .cheques-pill--danger { background: var(--app-color-danger-soft); border-color: var(--app-color-danger-border); color: var(--app-color-danger); }
  .cheques-pill--info { background: var(--app-color-info-soft); border-color: var(--app-color-info-border); color: var(--app-color-info); }
  .cheques-pill--primary { background: var(--app-color-primary-soft); border-color: var(--app-color-info-border); color: var(--app-color-primary-active); }
  .cheques-pill--neutral { background: var(--app-color-surface-subtle); border-color: var(--app-color-border-strong); color: var(--app-color-text-secondary); }
  /* franja de estado a la izquierda de cada fila */
  .cheques-detail-movimientos >>> tr.cheques-row td:first-child { box-shadow: inset 5px 0 0 var(--cheques-row-color, transparent); }
  .cheques-detail-movimientos >>> tr.cheques-row--success { --cheques-row-color: var(--app-color-success); }
  .cheques-detail-movimientos >>> tr.cheques-row--warning { --cheques-row-color: var(--app-color-warning); }
  .cheques-detail-movimientos >>> tr.cheques-row--warning td { background: var(--app-color-warning-soft); }
  .cheques-detail-movimientos >>> tr.cheques-row--primary { --cheques-row-color: var(--app-color-primary); }
  .cheques-detail-movimientos >>> tr.cheques-row--primary td { background: var(--app-color-primary-soft); }
  .cheques-detail-movimientos >>> tr.cheques-row--danger { --cheques-row-color: var(--app-color-danger); }
  .cheques-detail-movimientos >>> tr.cheques-row--danger td { background: var(--app-color-danger-soft); }
  .cheques-detail-movimientos >>> tr.cheques-row--neutral { --cheques-row-color: var(--app-color-border-strong); }
  .cheques-detail-movimientos >>> tr.cheques-row--neutral td { background: var(--app-color-surface-subtle); color: var(--app-color-text-secondary); }
  .cheques-detail-movimientos >>> tr.cheques-row--neutral td strong,
  .cheques-detail-movimientos >>> tr.cheques-row--neutral td b { color: var(--app-color-text-secondary); }
  /* estado: etiqueta sólida (se distingue de las etiquetas suaves de vencimiento) */
  .cheques-status { align-items: center; border: 1px solid transparent; border-radius: 6px; color: #fff; display: inline-flex; font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); gap: 4px; line-height: 1.5; padding: 3px 9px; white-space: nowrap; }
  .cheques-status .material-symbols-rounded { font-size: 15px; }
  .cheques-status--success { background: var(--app-color-success); }
  .cheques-status--warning { background: var(--app-color-warning); }
  .cheques-status--primary { background: var(--app-color-primary); }
  .cheques-status--danger { background: var(--app-color-danger); }
  .cheques-status--neutral { background: var(--app-color-surface); border-color: var(--app-color-border-strong); color: var(--app-color-text-secondary); }
  .cheques-kpis { display: grid; gap: 10px; grid-template-columns: repeat(4, minmax(0, 1fr)); margin: 8px 0; }
  .cheques-kpi { align-items: center; background: var(--app-color-surface); border: 1px solid var(--app-color-border); border-radius: 9px; cursor: pointer; display: flex; gap: 12px; padding: 12px 14px; text-align: left; transition: border-color .15s, box-shadow .15s; }
  .cheques-kpi:hover { box-shadow: 0 3px 10px rgba(7, 58, 78, 0.10); }
  .cheques-kpi__icon { align-items: center; border-radius: 50%; display: inline-flex; flex: 0 0 40px; height: 40px; justify-content: center; }
  .cheques-kpi__icon .material-symbols-rounded { font-size: 21px; }
  .cheques-kpi__body { display: grid; min-width: 0; }
  .cheques-kpi__body small { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); text-transform: uppercase; }
  .cheques-kpi__body strong { color: var(--app-color-text); font-size: 18px; line-height: 1.3; }
  .cheques-kpi__body span { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); }
  .cheques-kpi--portfolio .cheques-kpi__icon { background: var(--app-color-success-soft); color: var(--app-color-success); }
  .cheques-kpi--pending .cheques-kpi__icon { background: var(--app-color-warning-soft); color: var(--app-color-warning-hover); }
  .cheques-kpi--expiring .cheques-kpi__icon { background: var(--app-color-info-soft); color: var(--app-color-info); }
  .cheques-kpi--rejected .cheques-kpi__icon { background: var(--app-color-danger-soft); color: var(--app-color-danger); }
  .cheques-kpi--rejected.cheques-kpi--active { border-color: var(--app-color-danger-border); box-shadow: inset 0 -3px 0 var(--app-color-danger); }
  .cheques-kpi--portfolio.cheques-kpi--active { border-color: var(--app-color-success-border); box-shadow: inset 0 -3px 0 var(--app-color-success); }
  .cheques-kpi--pending.cheques-kpi--active { border-color: var(--app-color-warning-border); box-shadow: inset 0 -3px 0 var(--app-color-warning); }
  .cheques-tabs { margin-bottom: 8px; }
  .cheques-tab-pending { margin-bottom: 8px; }
  @media (max-width: 1199.98px) { .cheques-kpis { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
  @media (max-width: 767.98px) { .cheques-kpis { grid-template-columns: 1fr; } }
  .cheques-table.app-table th,
  .cheques-table.app-table td { padding: 0.55rem 0.6rem; }
  .cheques-cell-main { display: grid; gap: 2px; }
  .cheques-cell-main strong { color: var(--app-color-text); font-weight: var(--app-font-semibold); }
  .cheques-cell-meta { align-items: center; color: var(--app-color-text-secondary); display: inline-flex; font-size: var(--app-text-xs); gap: 6px; margin-top: 4px; }
  .cheques-cell-meta .material-symbols-rounded { color: var(--app-color-primary); font-size: 16px; vertical-align: -3px; }
  .cheques-observations-chip { align-items: center; background: var(--app-color-primary-soft); border-radius: 999px; color: var(--app-color-primary-active); cursor: help; display: inline-flex; font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); gap: 3px; padding: 2px 7px; }
  .cheques-observations-chip .material-symbols-rounded { color: inherit; font-size: 14px; vertical-align: 0; }
  .cheques-circuit-row { align-items: baseline; cursor: pointer; display: flex; gap: 6px; line-height: 1.45; }
  .cheques-circuit-row + .cheques-circuit-row { border-top: 1px solid var(--app-color-border); margin-top: 3px; padding-top: 3px; }
  .cheques-circuit-row > span { color: var(--app-color-text-secondary); flex: 0 0 48px; font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); text-transform: uppercase; }
  .cheques-circuit-row > strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .cheques-page-footer { background: var(--app-color-surface); border: 1px solid var(--app-color-border-strong); box-shadow: 0 -3px 12px rgba(7, 58, 78, 0.13), 0 6px 16px rgba(7, 58, 78, 0.11); }
  .btn.cheques-action-toggle-labeled { align-items: center; background: transparent !important; border: none !important; box-shadow: none !important; color: var(--app-color-text-secondary) !important; display: inline-flex !important; font-size: var(--app-text-sm); height: auto !important; justify-content: flex-start; min-height: 0; padding: 0 !important; width: auto !important; }
  .btn.cheques-action-toggle-labeled:hover,
  .btn.cheques-action-toggle-labeled:focus { color: var(--app-color-primary) !important; text-decoration: underline; }
</style>
